import React, { useEffect, useRef, useState } from "react";

import { XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useSearchParams } from "react-router-dom";

// Doc-name search only. No app filter: browsing by app belongs to
// /apps/:id. No closed toggle: the Open/Closed segmented tabs in PrdTable
// own the ?status= param.
export const PrdToolbar = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const q = searchParams.get("q") || "";
  const isFiltered = !!q;

  const [inputValue, setInputValue] = useState(q);
  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Sync external q (e.g. on reset) into the local input
  useEffect(() => {
    setInputValue(q);
  }, [q]);

  // Pending debounce must not fire setSearchParams after unmount
  useEffect(
    () => () =>
      clearTimeout(debounceTimer.current as ReturnType<typeof setTimeout>),
    []
  );

  const setQ = (value: string) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (value) {
        next.set("q", value);
      } else {
        next.delete("q");
      }
      return next;
    });
  };

  const handleQChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    clearTimeout(debounceTimer.current as ReturnType<typeof setTimeout>);
    debounceTimer.current = setTimeout(() => {
      setQ(value);
    }, 1000);
  };

  const handleQBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    clearTimeout(debounceTimer.current as ReturnType<typeof setTimeout>);
    setQ(e.target.value);
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder="Filter doc name…"
          value={inputValue}
          onChange={handleQChange}
          onBlur={handleQBlur}
          className="h-8 w-[150px] lg:w-[250px]"
        />
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => setQ("")}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <XIcon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default PrdToolbar;
